/*
*###############################################################################
*Module Name                   : UserMaster.js                                 #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, September 6th 2021, 12:14:16 am       #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    TabContent,
    TabPane,
    Alert
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import DPAlert from "framework/widgets/DPAlert"
import DPInfoBox from "framework/layout/DPInfoBox"
import Noimage from "assets/images/product/noimage.jpg"
import { Text, Numeric } from "../../../framework/validators/TextValidation"

import UserMasterTab1 from "./UserMasterTab1"
import UserMasterTab2 from "./UserMasterTab2"
import UserMasterTab3 from "./UserMasterTab3"
import UserMasterTab4 from "./UserMasterTab4"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
import { GeneratePasswordBarcode, GetAllUserData } from "./UserMasterController"
import { MENUPERMISSION_USER_INACTIVE } from "Permission_Rules"

const photovalues = {
    imageSrc: Noimage,
    imageFile: "",
    imagepath: ""
}


const UserMaster = (props) => {

    let history = useHistory();
    //********Tab 1*/
    const [code, SetCode] = useState("")
    const [fName, SetFName] = useState("")
    const [lName, SetLName] = useState("")
    const [name, SetName] = useState("")
    const [password, SetPassword] = useState("")
    const [signID, SetSignID] = useState("")
    const [barcode, SetBarcode] = useState("")
    const [group, SetGroup] = useState("")
    const [nic, SetNIC] = useState("")
    const [status, SetStatus] = useState(false)
    const [photo, SetPhoto] = useState(photovalues)//photoooooooooooo
    const [gender, SetGender] = useState("")
    const [dob, SetDob] = useState("")
    const [jobDesig, SetJobDesig] = useState("")
    const [maxDis, SetMaxDis] = useState("0.0")
    const [managerSign, SetManagerSignReq] = useState(false)
    const [Alllocation, SetLocation] = useState([])
    const [newPassword, SetNewPassword] = useState("")
    const [confirmPassword, SetConfirmPassword] = useState("")
    const [reason, SetReason] = useState("")
    const [logAlert, SetLogAlert] = useState(false)

    const [name1, Setname1] = useState("")
    const [name2, setname2] = useState("")
    const [conPass, SetConPass] = useState("")
    const [currentPass, SetCurrentPass] = useState("")
    const [ssoDisable, SetSsoDisable] = useState(false)
    const [authType, SetAuthType] = useState("")
    const [aithID, SetAuthID] = useState("")
    const [passdisabled, SetPassdisabled] = useState(false)
    const [menuCode, SetMenuCode] = useState("")
    const [appuser, SetAppUser] = useState("")
    const [employee, setEmployee] = useState("")
    const [handleClearTrigger, setHandleClearTrigger] = useState(false)
    //********Tab 1 End*/

    //********Tab 2*/
    const [add1, SetAdd1] = useState("")
    const [add2, SetAdd2] = useState("")
    const [add3, SetAdd3] = useState("")
    const [add4, SetAdd4] = useState("")
    const [area, SetArea] = useState("")
    const [phone, SetPhone] = useState("")
    const [email, SetEmail] = useState("")
    //********Tab 2 End*/

    //********Tab 3 */
    const [float, SetFloat] = useState("0.0")
    const [cSignon, SetCSignon] = useState(false)
    const [csignoff, SetCsignoff] = useState(false)
    const [tempsin, SetTempSign] = useState(false)
    const [managesign, SetManagesign] = useState(false)
    //********Tab 3 End*/

    //********Tab 4 */
    const [ucode, SetuCode] = useState("")
    const [asignlocation, SetAsignLocation] = useState("")
    const [startdate, SetStartDate] = useState("")
    const [enddate, SetEndDate] = useState("")
    const [actState, SetActState] = useState(true)
    //********Tab 4 End*/

    /**** InfoBox usestes */
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    /********************************/

    const [saveEnable, setSaveEnable] = useState(true)
    const [vasRow, setVasRow] = useState([{
        id: 1,
        locode: "",
        desc: "",
        loStart: "",
        loEnd: "",
        state: false,
        isDisabled: false

    }])

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [dobState, SetDobState] = useState(false)
    const [imgName, setImgName] = useState("")
    const [filevalue, SetFileValue] = useState("")
    const [passEnable, SetPassEnable] = useState(false)
    const [groupDisable, SetGroupDisable] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [checkUser, SetCheckUser] = useState(false)
    const [checkAdmin, SetCheckAdmin] = useState(false)
    //*** End User activity related staes */


    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    const [showalert, setShowAlert] = useState(false)
    const [myAlertMessage, setMyAlertMessage] = useState('')
    const [myAlertError, setMyAlertError] = useState('')
    const [myAlertColor, setMyAlertColor] = useState('')
    //*** Get and Set values when user search code */

    //*****Alert Time setter */
    var time = process.env.REACT_APP_ALERTTIMEOUT

    //Display only fields
    const [signlocation, SetSignLocation] = useState("")
    const [terminalID, SetTerminalID] = useState("")
    const [signOnDate, SetSignOnDate] = useState("")
    const [signOnTime, SetSignOntime] = useState("")
    const [shift, SetShift] = useState("")
    const [signOffDate, SetSignOffDate] = useState("")
    const [signOffTime, SetSignOffTime] = useState("")

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    const [signInUser, setSignInUser] = useState("")

    const [currentPage, setCurrentPage] = useState(1)
    const [helpUrl, setHelpUrl] = useState("")
    //import from contexts
    const {
        isHeadOffice, getMenuDetails, passwordpolicy, passwordPolicyDescription, addtoFavourite, mobileNumberRegexp, emailRegexp, fetchAutoCode, masterAuditLog, getSelectedMasterPermissions, MenuUserpermission
    } = useContext(Context);
    //import from contexts

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")


    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)



        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)

        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

        function getLocation() {
            var requestOptions = {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                redirect: 'follow'
            };
            fetch(`${ApiURL}Locations/select`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.success) {
                        SetLocation(result.data)
                    } else {
                        SetLocation([])
                    }
                }).catch(error => console.log('error', error));
        }

        getLocation()

    }, [handleClearTrigger])


    // AuditLog
    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

    }, [])


    const GetUserData = async (searchcode) => {
        let logedLocation
        if (searchcode == "") return

        if (validateSpecialCharacters(searchcode) == true) {
            SetCode("")
            return
        }

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")
        const { isSuccess, data, error } = await GetAllUserData(searchcode)
        SetLoadingAlert(false)
        if (isSuccess) {

            let modifiedLocations = []
            SetCode(data.strUserCode)
            SetFName(data.strUserFname)
            SetLName(data.strUserLName)
            SetName(data.strUserFullName)
            SetSignID(data.strSignOnId)
            SetBarcode(data.strPasswordBarcode)
            SetGroup(data.strUserGroup)
            SetNIC(data.strNIC)
            NicValidate(data.strNIC)
            SetStatus(data.status)
            SetGender(data.strGender)
            SetDob(data.strDOB.slice(0, 10))
            SetJobDesig(data.strDesignation)
            SetMaxDis(data.dbMaxDisount)
            SetManagerSignReq(data.intSkipBKOff)
            SetAdd1(data.strUserAddress1)
            SetAdd2(data.strUserAddress2)
            SetAdd3(data.strUserAddress3)
            SetAdd4(data.strUserAddress4)
            SetArea(data.strUserArea)
            SetArea(data.strUserArea)
            SetPhone(data.strUserMobile)
            SetEmail(data.strUserEmail)
            SetFloat(data.dbFloat)
            SetCSignon(data.intIsSignOn)
            SetCsignoff(data.intIsSignOff)
            SetTempSign(data.intTempSignOn)
            SetManagesign(data.intIsManagmentSignOff)
            setCrBy(data.createdBy)
            setMdBy(data.modifiedBy)
            setCrDate(data.createdDate)
            setMdDate(data.modifiedDate == "1900-01-01T00:00:00" ? "" : data.modifiedDate)

            /* Changed by : Madhura Liyanage
            Changed On : 30/11/2022
            Reason : Changed all image storage/accessing location to media server
            */
            //---------Beginning of change ---------------------------------------------------------------------------------------------------------------
            //SetPhoto(data.strPhotoPath == "images/user/" ? photovalues : {

            //}), setImgName(data.strPhotoPath)
            SetPhoto(data.strPhotoPath == "images/user/" ? photovalues : {
                imageSrc: `${window.Links.MediaServer + localStorage.getItem("Serial") + "/"}${data.strPhotoPath}`
            }), setImgName(data.strPhotoPath)
            SetFileValue("");

            logedLocation = data.strSignLocation
            SetTerminalID(data.strStation)
            SetSignOnDate(data.dtSignOnDate)
            SetSignOntime(data.dtSignOnTime)
            SetShift(data.intShitNo)
            SetSignOffDate(data.dtSignOffDate)
            SetSignOffTime(data.dtSignOffTime)
            SetAuthID(data.strSSOToken)
            SetAppUser(data.intAppUser)
            setEmployee(data.employee)
            SetAuthType(data.strSSOPlatform)

            data.userlocationdetails.map((dr) => {
                modifiedLocations.push({
                    id: modifiedLocations.length + 1,
                    locode: dr.uL_LOC,
                    desc: dr.uL_LOCDESC,
                    loStart: dr.uL_DATEFROM.slice(0, 10),
                    loEnd: dr.uL_DATETO.slice(0, 10),
                    state: dr.uL_ACTIVE,
                    isDisabled: true
                })
            })

            if (LogUserType == data.strUserCode || data.strUserGroup == "ADM" || data.strUserGroup == "SADM") {
                SetPassEnable(true)
                SetPassdisabled(false)
                SetCheckUser(true)
            } else {
                SetPassdisabled(true)
            }

            setVasRow(modifiedLocations == undefined || modifiedLocations.length == 0 ? [{
                id: 1,
                locode: "",
                desc: "",
                loStart: "",
                loEnd: "",
                state: false,
                isDisabled: false

            }] : modifiedLocations)
            SetAddNew(false)
            setDisabled(true)
            setDisabledCode(true)
            setSaveEnable(false)
            setCrEnable(true)
            SetSsoDisable(true)
            SetDeleteEnable(true)
            setReason("Updated")
            SetEditEnable(true)

            for (var i = 0; i < Alllocation.length; i++) {
                if (Alllocation[i].value == logedLocation) {
                    SetSignLocation(Alllocation[i]["label"])

                }
            }
        }
    }

    //SSO functions

    const responseOnSuccess = (id, authType, authemail) => {
        SetAuthID(id)
        SetAuthType(authType)
        SetSignID(authemail)

        if (email == "") {
            SetEmail(authemail)
        }

    }

    const responseOnFailure = (response) => {
        console.log(response);
    }

    //
    //save button function    
    const handlesave = async () => {


        //set autogenerate code to as CODE just for display purpuse
        if (addNew == true && nullCode == false) {
            SetCode(autoCode)
        }

        var mobilePattern = new RegExp(mobileNumberRegexp);
        var emailPattern = new RegExp(emailRegexp)
        var password_pattern = new RegExp(passwordpolicy)

        if (code == "" && nullCode == true) {
            displayAlertMessage('danger', "Please Enter User Code !")
            return;
        }

        if (fName == "") {
            displayAlertMessage('danger', "Please Enter First Name !")
            return;
        }

        if (LogUserType == code) {
            if (password != "" && currentPass == "") {
                displayAlertMessage('danger', "Please Enter Current Password !")
                return;
            }
        }

        if (addNew == true && password == "" || conPass == "") {
            // displayAlertMessage('danger', "Please Enter Password !")
            // return;
        } else if (password != "" && conPass == "") {
            displayAlertMessage('danger', "Please Enter Confirm Password !")
            return;

        } else if (password_pattern.test(password)) {
            if (password.localeCompare(conPass) != 0) {
                displayAlertMessage('danger', "Password and Confirm Password not matching !")
                return;
            }
        } else {
            displayAlertMessage('danger', passwordPolicyDescription)
            return;
        }


        if (barcode.length == 0 || barcode == "") {
            displayAlertMessage('danger', "Please Enter Password barcode !")
            return;
        }

        if (barcode.length < 6) {
            displayAlertMessage('danger', "Barcode length should have minimum 6 characters !")
            return;
        }

        if (group == "") {
            displayAlertMessage('danger', "Please Select Group Code !")
            return;
        }

        if (add1 == "") {
            displayAlertMessage('danger', "Please Enter Address 1 !")
            return;
        }

        if (area == "") {
            displayAlertMessage('danger', "Please Select User Area !")
            return;
        }

        if (phone == "") {
            displayAlertMessage('danger', "Please Enter Phone number !")
            return;

        } if (!mobilePattern.test(phone)) {
            displayAlertMessage('danger', "Phone number is not Valid")
            return;

        } else if (phone.length < 10) {
            displayAlertMessage('danger', "Phone number is wrong")
            return;
        }

        if (email != "") {
            if (emailPattern.test(email) == false) {
                displayAlertMessage('danger', "Invalid Email !")
                return;
            }

        }

        if (addNew == false && currentPass != "" && password == "") {
            displayAlertMessage('danger', "Please Enter Your New Password !")
            return;
        }

        if (dob.slice(8,) > 31) {
            displayAlertMessage('danger', "Invalid DOB !")
            return;
        }

        var locationtable = [];

        var startDate = []
        var endDate = []

        vasRow.forEach((row, index) => {

            if (row.locode != "") {
                if (row.loStart == "") {
                    startDate.push(index + 1)
                } else if (row.loEnd == "") {
                    endDate.push(index + 1)
                }
                locationtable.push(UserLocationBuider(code, row.locode, row.loStart, row.loEnd, row.state))
            }
        });

        if (startDate.length > 0) {
            displayAlertMessage('danger', "Please Enter Start Date in Row " + startDate[0])
            return;
        }

        if (endDate.length > 0) {
            displayAlertMessage('danger', "Please Enter End Date in Row " + endDate[0])
            return;
        }


        var intSkipBKOff = managerSign == true ? 1 : 0

        const strCodeToUse = addNew == true && nullCode == false ? autoCode : code

        if (strCodeToUse === "") {
            displayAlertMessage('danger', "Please Enter user code")
            return;
        };


        var image = await CustomerMasterImageUpload(strCodeToUse)



        var raw = JSON.stringify({
            "strUserCode": strCodeToUse,
            "strUserFname": fName,
            "strUserLName": lName,
            "strUserFullName": name,
            "strUserPassword": addNew == true && password == "" ? code : addNew == true && password != "" ? password : currentPass,
            "strNewPassword": addNew == true && password != "" ? "" : password,
            "strSignOnId": signID,
            "strPasswordBarcode": barcode,
            "strUserGroup": group,
            "strNIC": nic,
            "IsStatus": status,
            "strPhotoPath": image,
            "strGender": gender,
            "strDOB": dob == "" ? "1900-01-01T00:00:00" : dob,
            "strDesignation": jobDesig,
            "dbMaxDisount": parseFloat(maxDis),
            "intSkipBKOff": intSkipBKOff,
            "strUserAddress1": add1,
            "strUserAddress2": add2,
            "strUserAddress3": add3,
            "strUserAddress4": add4,
            "strUserArea": area,
            "strUserMobile": phone,
            "strUserEmail": email,
            "strSignLocation": "",//LocationCode,
            "strStation": "",
            "dtSignOnDate": "1900-01-01T00:00:00",
            "dtSignOnTime": "1900-01-01T00:00:00",
            "intShitNo": 0,
            "dbFloat": 0.00,//parseFloat(float),
            "dtSignOffDate": "1900-01-01T00:00:00",
            "dtSignOffTime": "1900-01-01T00:00:00",
            "intIsSignOn": 0,//intIsSignOn,
            "intIsSignOff": 1,//intIsSignOff,
            "intTempSignOn": 0,//intTempSignOn,
            "intIsManagmentSignOff": 1,//intManageSignOff,
            "strCreateBy": LogUserType,
            "strMenuCode": menuCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "blAddNew": addNew,
            "strSSOPlatform": authType,
            "strSSOToken": aithID,
            "USERLOCATIONDETAILS": locationtable,
            "intAppUser": appuser == true ? 1 : 0,
            "employee": employee,
        })

        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        var requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: raw
        };

        fetch(`${ApiURL}User`, requestOptions)
            .then(response => {
                if (response.status == "200") {
                    SetLoadingAlert(false)
                    response.json()
                        .then(responseData => {
                            if (responseData.data == "Record Already Exsist!") {
                                displayAlertMessage('danger', responseData.data)

                            } else if (responseData.data == "Code Already Exsist!") {
                                displayAlertMessage('danger', responseData.data)
                                setCodeButton(false)

                            } else if (responseData.data == "Current password Incorrect.please Enter password Again") {
                                displayAlertMessage('danger', responseData.data)

                            } else if (responseData.data == "SSO Token Already Exsist!") {
                                displayAlertMessage('danger', responseData.data)

                            } else if (responseData.data == "Invalid Password Barcode!") {
                                displayAlertMessage('danger', responseData.data)

                            } else {
                                ClearItem();
                                displayAlertMessage('success', responseData.data)
                            }

                        }
                        )
                } else if (response.status == "400") {
                    SetLoadingAlert(false)
                    response.json()
                        .then(responseData => {
                            setErrorMsg(responseData.title)
                            setDisabled(false)
                            displayAlertMessage('danger', responseData.msg)
                        })

                } else if (response.status == "500") {
                    SetLoadingAlert(false)
                    response.json()
                        .then(responseData => {
                            setErrorMsg(responseData.msg)
                            displayAlertMessage('danger', responseData.msg)
                        })
                    setDisabled(false)

                } else {
                    SetLoadingAlert(false)
                    ClearItem()
                }
            }
            ).catch(error => console.log('error', error));

    }


    const UserLocationBuider = (code, locode, lostart, loend, state) => {
        return {
            "UL_ID": code,
            "UL_LOC": locode,
            "UL_DATEFROM": lostart.slice(0, 10),
            "UL_DATETO": loend.slice(0, 10),
            "UL_ACTIVE": state,
            "UL_LOCDESC": ""
        }
    }


    const CustomerMasterImageUpload = async (strCodeToUse) => {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");
        let message = "";
        try {
            if (photo.imageFile) {
                const formdata = new FormData();

                formdata.append("strCode", strCodeToUse);
                formdata.append("img", photo.imageFile);
                formdata.append("strSerial", localStorage.getItem("Serial") || "");

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${authToken}`
                    },
                    body: formdata,
                    redirect: 'follow'
                };

                const response = await fetch(`${ApiURL}User/image`, requestOptions);
                const responseData = await response.json();

                if (responseData.success === true) {
                    message = responseData.data;
                }
            } else if (imgName) {
                message = imgName.slice(15);
            }

            // If neither picture.imageFile nor imgName is available, message remains an empty string.
        } catch (error) {
            console.error('Error:', error);
        }

        return message;
    };

    //************ Image Upload Function End*/

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetEditEnable(false)

    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function handleAddRowNestedVas() {
        const modifiedRows = [...vasRow]
        modifiedRows.push({ id: modifiedRows.length + 1, isDisabled: false })
        setVasRow(modifiedRows)
    }


    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //********* NIC Validation */
    const NicValidate = (NIC) => {

        var mon =
        {
            "1": ["01", 31],
            "2": ["02", 29],
            "3": ["03", 31],
            "4": ["04", 30],
            "5": ["05", 31],
            "6": ["06", 30],
            "7": ["07", 31],
            "8": ["08", 31],
            "9": ["09", 30],
            "10": ["10", 31],
            "11": ["11", 30],
            "12": ["12", 31]
        };

        if (NIC.length == 10) {
            let year = "19" + NIC.substr(0, 2);
            let days = parseInt(NIC.substr(2, 3));
            if (days > 500) {
                SetGender("F")
                days = days - 500;
            }
            else {
                SetGender("M")
            }
            let key;
            for (key in mon) {
                if (days > mon[key][1]) {
                    days = days - mon[key][1];
                }
                else {
                    break;
                }
            }
            if (days < 10) {
                days = "0" + days;
            }

            let date = year + "-" + mon[key][0] + "-" + days
            SetDob(date)
            SetDobState(true)

        } else if (NIC.length == 12) {

            // Definitions for month-day limits (not real; example purposes)
            const monthDayThreshold = 366;  // Example threshold for male

            if (NIC.length !== 12) {
                console.error("NIC must be exactly 12 digits long.");
                return;
            }

            let year = NIC.substr(0, 4);
            let combinedMonthDay = parseInt(NIC.substr(4, 3), 10);  // This is '054' in the example
            let sequence = NIC.substr(8, 4); // Optional use

            // Gender determination and adjusting day range
            let gender;
            if (combinedMonthDay > 500) {
                gender = "F";
                combinedMonthDay -= 500;
            } else {
                gender = "M";
            }

            // Set gender
            SetGender(gender);

            // Hypothetical method to determine month and day from combinedMonthDay
            // This needs specific logic based on how month and day are encoded in combinedMonthDay
            let month, day;
            if (combinedMonthDay <= monthDayThreshold) {
                // Calculate month and day (simple placeholder logic)
                month = Math.floor((combinedMonthDay - 1) / 31) + 1;
                day = (combinedMonthDay - 1) % 31 + 1;
            }

            // Validate extracted month and day
            if (month < 1 || month > 12 || day < 1 || day > 31) {
                console.error("Extracted month or day is out of valid range.");
                return;
            }

            // Formatting month and day for uniformity
            month = month.toString().padStart(2, '0');
            day = day.toString().padStart(2, '0');

            // Construct date of birth
            let dateOfBirth = `${year}-${month}-${day}`;

            // Set date of birth and toggle state
            SetDob(dateOfBirth);
            SetDobState(true);

        } else {
            SetDobState(false);
            console.error("NIC must be either 10 or 12 digits long.");
        }

    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetFName("")
        SetLName("")
        SetName("")
        SetPassword("")
        SetConPass("")
        SetSignID("")
        SetBarcode("")
        SetGroup("")
        SetNIC("")
        SetStatus(false)
        SetGender("")
        SetDob("")
        SetJobDesig("")
        SetMaxDis("0.0")
        SetManagerSignReq("")
        SetAdd1("")
        SetAdd2("")
        SetAdd3("")
        SetAdd4("")
        SetArea("")
        SetArea("")
        SetPhone("")
        SetEmail("")
        SetFloat("0.0")
        SetCSignon(false)
        SetCsignoff(false)
        SetTempSign(false)
        SetManagesign(false)
        setCrBy("")
        setMdBy("")
        setCrDate("")
        setMdDate("")
        setDisabledCode(false)
        setDisabled(false)
        setShow(false)
        setCrEnable(false)
        SetPhoto(photovalues)
        setImgName("")
        SetFileValue("")
        SetAddNew(true)
        SetDobState(false)
        setVasRow([{
            id: 1,
            locode: "",
            desc: "",
            loStart: "",
            loEnd: "",
            state: false,
            isDisabled: false

        }]),
            SetPassEnable(false)
        SetCurrentPass("")
        setAlertMsg("")
        setErrorMsg("")
        SetGroupDisable(false)
        SetSsoDisable(false)
        SetAuthType("")
        SetPassdisabled(false)
        SetAppUser(false)
        setEmployee("")
        SetCheckUser(false)
        SetTerminalID("")
        SetSignOnDate("")
        SetSignOntime("")
        SetShift("")
        SetSignOffDate("")
        SetSignOffTime("")
        SetSignLocation("")
        SetNewPassword("")
        SetConfirmPassword("")
        SetReason("")
        setShowAlert(false)
        setMyAlertMessage("")
        setMyAlertError("")
        SetCheckAdmin(false)
        setcustomActiveTab("1")
        setReason("Created")
        SetEditEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setErrorMsg("")
        setCurrentPage(1)
        setHandleClearTrigger(!handleClearTrigger)
    }

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.UH_ID);
        GetUserData(row.UH_ID)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)

    }

    const tabList = [
        {
            text: "General Information",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
                toggleCustom("1")
            }
        },
        {
            text: "Contact Details",
            icon: "far fa-user",
            tabID: "2",
            onClick: () => {
                toggleCustom("2")
            }
        },
        {
            text: "Shift Details",
            icon: "far fa-user",
            tabID: "3",
            onClick: () => {
                toggleCustom("3")
            }
        },
        {
            text: "Location Details",
            icon: "far fa-user",
            tabID: "4",
            onClick: () => {
                toggleCustom("4")
            }
        }
    ];

    const [customActiveTab, setcustomActiveTab] = useState("1")
    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab)
        }
    }

    //********Delete button function */
    const handleDelete = () => {


        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": code,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": crBy
        }

        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")
        fetch(`${ApiURL}Common/Delete`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(rowDelete)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        if (responseData.data == "Cannot Delete, Record Already Used!") {
                            displayAlertMessage('warning', responseData.data)

                        } else {
                            ClearItem();
                            displayAlertMessage('success', responseData.data)
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")

            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }
    //*********Delete button function end */


    function OnAccept() {

        var pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/

        if (code == "") {
            setMyAlertColor('danger')
            setMyAlertMessage("Select user first !")
            setShowAlert(true)
            setTimeout(() => {
                setShowAlert(false)
            }, time)
            return;
        }

        if (newPassword == "" || confirmPassword == "") {
            setMyAlertMessage("Please enter new password and confirm password")
            setMyAlertColor('danger')
            setShowAlert(true)
            setTimeout(() => {
                setShowAlert(false)
            }, time)
            return
        }

        if (pattern.test(newPassword) == false) {
            setMyAlertColor('danger')
            setMyAlertMessage("Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character")
            setShowAlert(true)
            setTimeout(() => {
                setShowAlert(false)
            }, time)
            return;

        }

        if (newPassword != confirmPassword) {
            setMyAlertColor('danger')
            setMyAlertMessage("Passwords does not match !")
            setShowAlert(true)
            setTimeout(() => {
                setShowAlert(false)
            }, time)
            return;
        }

        if (reason == "") {
            setMyAlertColor('danger')
            setMyAlertMessage("Please enter reason  !")
            setShowAlert(true)
            setTimeout(() => {
                setShowAlert(false)
            }, time)
            return;
        }
        const passwordReset = {
            "strUserCode": code,
            "strNewPassword": newPassword,
            "strMenuCode": menuCode,
            "strLoggedLocation": LocationCode,
            "strLoggedCompany": LogCompanyCode,
            "strReason": reason,
            "strCreateBy": LogUserType
        }

        // SetLoadingAlert(true)
        // SetLoadingAlerttitle("Updating...")

        fetch(`${ApiURL}User/reset/password`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(passwordReset)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {

                        if (responseData.data == "Current password and new password are same !") {
                            setMyAlertColor('warning')
                            setMyAlertMessage(responseData.data)
                            setShowAlert(true)
                            setTimeout(() => {
                                setShowAlert(false)
                            }, time)
                        } else {
                            ClearItem();
                            setShowAlert(true)
                            setMyAlertMessage(responseData.data)
                            setMyAlertColor('success')
                            setTimeout(() => {
                                SetLogAlert(false)
                            }, time)
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setMyAlertError(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                setMyAlertColor('danger')
                setMyAlertMessage("Error !")
                setShowAlert(true)
                setTimeout(() => {
                    setShowAlert(false)
                }, time)
            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })

        setTimeout(() => {
            setShowAlert(false)
        }, time)

    }

    function OnSSOReset() {

        if (code == "") {
            setMyAlertColor('danger')
            setMyAlertMessage("Select user first !")
            setShowAlert(true)
            setTimeout(() => {
                setShowAlert(false)
            }, time)
            return;
        }
        const resetSSO = {
            "strUserCode": code,
            "strMenuCode": menuCode,
            "strLoggedLocation": LocationCode,
            "strLoggedCompany": LogCompanyCode,
            "strReason": reason,
            "strCreateBy": LogUserType
        }

        // SetLoadingAlert(true)
        // SetLoadingAlerttitle("Updating...")

        fetch(`${ApiURL}User/reset/sso`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(resetSSO)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {

                        setShowAlert(true)
                        setMyAlertMessage("SSO Reset Success")
                        setMyAlertColor('success')
                        setTimeout(() => {
                            SetLogAlert(false)
                        }, time)
                        SetAuthType("")
                        SetAppUser("")
                        SetAuthID("")
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setMyAlertError(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                setMyAlertColor('danger')
                setMyAlertMessage("Error !")
                setShowAlert(true)
                setTimeout(() => {
                    setShowAlert(false)
                }, time)
            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
        setTimeout(() => {
            setShowAlert(false)
        }, time)
    }

    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }

    function RemoveImage() {
        SetPhoto(photovalues)
        setImgName("")
        SetFileValue("")
    }



    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }



    //Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    const validateSpecialCharacters = (str) => {
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
        return specialCharRegex.test(str);
    };

    const GetPasswordBarcode = async () => {
        const { isSuccess, data, error } = await GeneratePasswordBarcode()

        if (isSuccess) {
            SetBarcode(data)
        } else {
            displayAlertMessage('danger', error)
        }

    }


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={() => {
                            setsweetAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                window.location.href = "/";
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            }
                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, true, "any", true)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={async () => {
                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                permission("Save")
                            } else if (AlertConfirmOption == 5) {
                                permission("Delete")
                            } else if (AlertConfirmOption == 6) {
                                permission("Print")
                            } else if (AlertConfirmOption == 10) {

                                try {

                                    SetLoadingAlert(true)
                                    SetLoadingAlerttitle("Permission Checking...")

                                    const permissonResponse = await MenuUserpermission(permissionName, permissionPassword, MENUPERMISSION_USER_INACTIVE)
                                    if (permissonResponse?.strMenuAccessRight == true) {
                                        SetStatus(true)
                                    } else {
                                        displayAlertMessage('danger', "This User don't have permission to activate this field !")
                                    }
                                    setPermissionPassword("")
                                } catch {
                                    displayAlertMessage('danger', "This User don't have permission to activate this field !")
                                } finally {
                                    SetLoadingAlert(false)
                                }

                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                            clearPermissionInputs()


                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={false}
                                        printClick={() => {
                                            alert("Print")
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Delete")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <DPNavBar
                                        buttons={tabList}
                                        activeStatus={customActiveTab}
                                    />
                                    <TabContent
                                        activeTab={customActiveTab}
                                        className="p-3 text"
                                    >{show ? (
                                        <Alert color={AlertColor} role="alert">
                                            {AlertMsg}
                                            <br />
                                            <small>{ErrorMsg}</small>
                                        </Alert>
                                    ) : null}
                                        <TabPane tabId="1">
                                            <UserMasterTab1
                                                codeValue={code}
                                                disableCode={disabledCode}
                                                CodeOnChange={e => {
                                                    var val1 = Text(e.target, 10, true, false, "upper", false)
                                                    SetCode(val1)
                                                }}
                                                CodeOnblur={e => {

                                                    GetUserData(e.target.value)
                                                }}
                                                fnameValue={fName}
                                                fnameOnChange={e => {
                                                    var val2 = Text(e.target, 50, true, false, "any", true)
                                                    SetFName(val2)
                                                }}
                                                lnameValue={lName}
                                                lnameOnChange={e => {
                                                    var val3 = Text(e.target, 50, true, false, "any", true)
                                                    SetLName(val3)
                                                }}
                                                nameValue={name}
                                                nameOnChange={e => {
                                                    var val4 = Text(e.target, 50, true, false, "any", true)
                                                    SetName(val4)
                                                }}
                                                passwordValue={password}
                                                passwordOnChange={e => {
                                                    var val5 = Text(e.target, 20, true, true, "any", false)
                                                    SetPassword(val5)
                                                }}
                                                signidValue={signID}
                                                signidOnChange={e => {
                                                    var val6 = Text(e.target, 50, true, true, "any", false)
                                                    SetSignID(val6)
                                                }}
                                                barcodeValue={barcode}
                                                barcodeOnChange={e => {
                                                    var val7 = Text(e.target, 25, true, true, "any", false)
                                                    SetBarcode(val7)
                                                }}
                                                groupValue={group}
                                                groupOnChange={e => {
                                                    SetGroup(e["value"])
                                                }}
                                                nicValue={nic}
                                                nicOnChange={e => {
                                                    var val7 = Text(e.target, 12, true, false, "upper", false)
                                                    var nicPattern1 = /[0-9]{12}/;
                                                    var nicPattern2 = /[0-9]{9}[V|X|v|x]/;
                                                    // if (nicPattern1.test(val7) == true && val7.length == 12) {
                                                    //     var num01 = nic.slice(2,)
                                                    //     var num02 = num01.slice(0, 9)
                                                    //     var num4 = num02 + "V"
                                                    //     NicValidate(num4)
                                                    // } else if (nicPattern2.test(val7) == true && val7.length == 10) {
                                                    //     NicValidate(val7)
                                                    // } else {
                                                    //     SetDobState(false)
                                                    // }
                                                    NicValidate(val7)
                                                    SetNIC(val7)
                                                }}
                                                genderValue={gender}
                                                genderOnChange={e => {
                                                    SetGender(e["value"])
                                                }}
                                                dobValue={dob}
                                                dobOnChange={e => {
                                                    SetDob(e.target.value)
                                                }}
                                                jobValue={jobDesig}
                                                jobOnChange={e => {
                                                    SetJobDesig(e["value"])
                                                }}
                                                discountValue={maxDis}
                                                discountOnChange={e => {
                                                    var val10 = Numeric(e.target, 5, 2, false)
                                                    SetMaxDis(val10)
                                                }}

                                                dicountOnblur={e => {
                                                    var val2 = parseFloat(e.target.value, 10)

                                                    if (e.target.value == "") {
                                                        SetMaxDis("0.0")
                                                    } else if (e.target.value <= 100) {
                                                        SetMaxDis(val2)
                                                    } else {
                                                        SetMaxDis("0.0")
                                                    }
                                                }}
                                                signoffValue={managerSign}
                                                signoffOnChange={e => {
                                                    SetManagerSignReq(!managerSign)
                                                }}
                                                activeValue={status}
                                                activeOnChange={e => {

                                                    if (e) {
                                                        setPermissionAlertShow(true)
                                                        setPermissionNameDisable(false)
                                                        setPermissionName("")
                                                        setAlertConfirmOption(10)
                                                    } else {
                                                        SetStatus(e)
                                                    }




                                                }}
                                                imagesrc={photo.imageSrc}
                                                ShowPreview={e => {

                                                    if (e.target.files && e.target.files[0]) {
                                                        let imageFile = e.target.files[0];
                                                        const reader = new FileReader();
                                                        SetFileValue(e.target.value)
                                                        reader.onload = x => {
                                                            SetPhoto({
                                                                imageFile,
                                                                imageSrc: x.target.result,
                                                                imagepath: e.target.value
                                                            })
                                                        }
                                                        reader.readAsDataURL(imageFile)
                                                    }
                                                    else {
                                                        SetFileValue("")
                                                        SetPhoto({
                                                            imageFile: null,
                                                            imageSrc: Noimage,
                                                            imagepath: null
                                                        })
                                                    }
                                                }}
                                                modelOpen={modal_xlarge}
                                                modelTrigger={tog_xlarge}
                                                GetSelectRow={GetSelectRow}
                                                disabled={disabled}
                                                nicOnBlur={e => {
                                                    var nicPattern1 = /[0-9]{12}/;
                                                    var nicPattern2 = /[0-9]{9}[V|X|v|x]/;

                                                    if (nicPattern1.test(e.target.value) == true) {

                                                    } else if (nicPattern2.test(e.target.value) == true && e.target.value.length == 10) {

                                                    } else if (e.target.value == "") {

                                                    }
                                                    else {
                                                        displayAlertMessage('danger', 'Invalid NIC number')
                                                        return
                                                    }
                                                }}
                                                DOBstate={dobState}
                                                filevalue={filevalue}
                                                FnameOnBlur={e => {

                                                    if (name == "" || name.length == 0) {
                                                        SetName(e.target.value + " " + lName)
                                                        Setname1(e.target.value)
                                                    } else if (name == name1 + " " + name2) {
                                                        SetName(e.target.value + " " + lName)
                                                    } else if (name != name1 + " " + name2) {
                                                        SetName(name)
                                                    }

                                                }}
                                                LnameOnBlur={e => {

                                                    if (name == "" || name.length == 0) {
                                                        SetName(fName + " " + e.target.value)
                                                        setname2(e.target.value)
                                                    } else if (name != name1 + " " + name2) {
                                                        SetName(name)
                                                    } else {
                                                        SetName(fName + " " + e.target.value)
                                                    }

                                                }}
                                                cpasswordValue={conPass}
                                                cpasswordOnChange={e => {
                                                    var val5 = Text(e.target, 20, true, true, "any", false)
                                                    SetConPass(val5)
                                                }}
                                                EnablePass={passEnable}
                                                currentPasswordValue={currentPass}
                                                currentPasswordOnChange={e => {
                                                    var val5 = Text(e.target, 20, true, true, "any", false)
                                                    SetCurrentPass(val5)
                                                }}
                                                GroupCodeDisable={groupDisable}
                                                SSODisable={ssoDisable}
                                                responseOnSuccess={responseOnSuccess}
                                                responseOnFailure={responseOnFailure}
                                                passdisabled={passdisabled}
                                                menuName={menuName}
                                                appUserOnChange={e => {
                                                    SetAppUser(!appuser)
                                                }}
                                                appUserValue={appuser}
                                                CheckUser={checkUser}
                                                AddNew={addNew}
                                                Code={code}
                                                Name={name}
                                                confirmPassword={confirmPassword}
                                                newPassword={newPassword}
                                                SetConfirmPassword={SetConfirmPassword}
                                                SetNewPassword={SetNewPassword}
                                                OnAccept={OnAccept}
                                                OnSSOReset={OnSSOReset}
                                                reason={reason}
                                                SetReason={SetReason}
                                                logAlert={logAlert}
                                                SetLogAlert={SetLogAlert}
                                                show={showalert}
                                                AlertColor={myAlertColor}
                                                AlertMsg={myAlertMessage}
                                                ErrorMsg={myAlertError}
                                                SignINUserType={signInUser}
                                                CheckAdmin={checkAdmin}
                                                onButtonClick={e => {
                                                    AutoGenerateCode()
                                                    setCodeButton(true)
                                                }}
                                                btnDisable={codeButton}
                                                SearchDisable={searchdisabled}
                                                menuCode={menuCode}
                                                signInUser={signInUser}
                                                RemoveImage={RemoveImage}
                                                GetPasswordBarcode={GetPasswordBarcode}
                                                setEmployee={(e) => {
                                                    const val = Text(e.target, 100, true, true, "any", true)
                                                    setEmployee(val)
                                                }}
                                                employee={employee}
                                            />
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <UserMasterTab2
                                                add1Value={add1}
                                                add1OnChange={e => {
                                                    var val1 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd1(val1)
                                                }}
                                                add2Value={add2}
                                                add2OnChange={e => {
                                                    var val2 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd2(val2)
                                                }}
                                                add3Value={add3}
                                                add3OnChange={e => {
                                                    var val3 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd3(val3)
                                                }}
                                                add4Value={add4}
                                                add4OnChange={e => {
                                                    var val4 = Text(e.target, 50, true, true, "any", true)
                                                    SetAdd4(val4)
                                                }}
                                                areaValue={area}
                                                areaonChange={e => {

                                                    SetArea(e["value"])
                                                }}
                                                phoneValue={phone}
                                                phoneOnChange={e => {
                                                    var val6 = Text(e.target, 12, true, true, "any", false)
                                                    SetPhone(val6)
                                                }}
                                                emailValue={email}
                                                emailOnChange={e => {
                                                    var val7 = Text(e.target, 50, true, true, "any", false)
                                                    SetEmail(val7)
                                                }}
                                                disable={disabled}
                                            />
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <UserMasterTab3
                                                floatValue={float}
                                                floatonChange={e => {
                                                    var val1 = Numeric(e.target, 10, 2, false)
                                                    SetFloat(val1)
                                                }}
                                                floatOnChange={e => {
                                                    SetFloat(parseFloat(e.target.value, 10))
                                                }}
                                                CsignOnValue={cSignon}
                                                CsignonOnChange={e => {
                                                    SetCSignon(!cSignon)
                                                }}
                                                CsignoffValue={csignoff}
                                                CsignoffOnChange={e => {
                                                    SetCsignoff(!csignoff)
                                                }}
                                                CtempsignValue={tempsin}
                                                CtempsignonChange={e => {
                                                    SetTempSign(!tempsin)
                                                }}
                                                manageSignValue={managesign}
                                                manageSignOnChange={e => {
                                                    SetManagesign(!managesign)
                                                }}
                                                disable={disabled}
                                                crEnable={crEnable}
                                                signlocation={signlocation}
                                                terminalID={terminalID}
                                                signOnDate={signOnDate}
                                                signOnTime={signOnTime}
                                                shift={shift}
                                                signOffDate={signOffDate}
                                                signOffTime={signOffTime}
                                            />
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <UserMasterTab4
                                                codeValue={ucode}
                                                codeOnChange={e => {
                                                    var val1 = Text(e.target, 10, true, false, "any", false)
                                                    SetuCode(val1)
                                                }}
                                                locationValue={asignlocation}
                                                locationOnChange={e => {
                                                    var val2 = Text(e.target, 10, true, false, "any", false)
                                                    SetAsignLocation(val2)
                                                }}
                                                satrtdateValue={startdate}
                                                startdateOnChange={e => {
                                                    SetStartDate(e.target.value)
                                                }}
                                                enddateValue={enddate}
                                                enddateOnChange={e => {
                                                    SetEndDate(e.target.value)
                                                }}
                                                activeValue={actState}
                                                activeOnChange={e => {
                                                    SetActState(!actState)
                                                }}
                                                AddRow={handleAddRowNestedVas}
                                                DataRow={vasRow}
                                                setVasRow={setVasRow}
                                                disabled={disabled}
                                                menuCode={menuCode}
                                                CheckAdmin={checkAdmin}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        </TabPane>
                                    </TabContent>
                                    {crEnable ? (
                                        <DPInfoBox
                                            createdBy={crBy}
                                            createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                            modifiedBy={mdBy}
                                            modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                        />
                                    ) : null}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}
export default UserMaster